webpackJsonp([145262073310797,281043220932899,106686655926796],{

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sketchRetina2x = __webpack_require__(452);
	
	var _sketchRetina2x2 = _interopRequireDefault(_sketchRetina2x);
	
	var _sketchPrototyping2x = __webpack_require__(451);
	
	var _sketchPrototyping2x2 = _interopRequireDefault(_sketchPrototyping2x);
	
	var _collaborateSketch2x = __webpack_require__(446);
	
	var _collaborateSketch2x2 = _interopRequireDefault(_collaborateSketch2x);
	
	var _devices2x = __webpack_require__(447);
	
	var _devices2x2 = _interopRequireDefault(_devices2x);
	
	var _record2x = __webpack_require__(450);
	
	var _record2x2 = _interopRequireDefault(_record2x);
	
	var _handoff2x = __webpack_require__(449);
	
	var _handoff2x2 = _interopRequireDefault(_handoff2x);
	
	var _embedSketch2x = __webpack_require__(448);
	
	var _embedSketch2x2 = _interopRequireDefault(_embedSketch2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assets = {
	  illustration: {
	    alt: 'Sketch',
	    src: _sketchRetina2x2.default
	  },
	  prototyping: {
	    alt: 'Prototyping',
	    src: _sketchPrototyping2x2.default
	  },
	  collaborate: {
	    alt: 'Collaborate',
	    src: _collaborateSketch2x2.default
	  },
	  devices: {
	    alt: 'Mobile',
	    src: _devices2x2.default
	  },
	  record: {
	    alt: 'Sketch',
	    src: _record2x2.default
	  },
	  handoff: {
	    alt: 'developer',
	    src: _handoff2x2.default
	  },
	  embed: {
	    alt: 'embed',
	    src: _embedSketch2x2.default
	  }
	};
	
	exports.default = assets;
	module.exports = exports['default'];

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/collaborate-sketch@2x-5b5269af79138465dabbb91b7f5c1ee1.jpg";

/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/devices@2x-b1265c42ec2d5b10ea93bb23c03469e7.png";

/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/embed-sketch@2x-a103d62b5f664f77fa162a6698bb46c4.jpg";

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/handoff@2x-bea4a77746924d84f022072d4c37cd01.png";

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/record@2x-f937bea12a316d7587257d67797e9bb9.png";

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sketch-prototyping@2x-a125ffd4fd5b739ace4ec4e7237b617e.jpg";

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sketch-retina@2x-38128008ad3ed9a0dc8aaff6a388d7e6.jpg";

/***/ }),

/***/ 1302:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Sketch;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _CtaDefault = __webpack_require__(61);
	
	var _CtaDefault2 = _interopRequireDefault(_CtaDefault);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _assets = __webpack_require__(122);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Whitespace = __webpack_require__(35);
	
	var _Whitespace2 = _interopRequireDefault(_Whitespace);
	
	var _FeaturesBlockList = __webpack_require__(235);
	
	var _FeaturesBlockList2 = _interopRequireDefault(_FeaturesBlockList);
	
	var _ImageBlock = __webpack_require__(236);
	
	var _ImageBlock2 = _interopRequireDefault(_ImageBlock);
	
	var _generalModule = __webpack_require__(760);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buttons = [{
	  text: 'Sign up free',
	  link: '/signup/',
	  styles: {
	    shape: 'rounded',
	    size: 'large',
	    minWidth: 160
	  }
	}, {
	  text: 'Explore Plans',
	  link: '/pricing/',
	  styles: {
	    shape: 'rounded',
	    size: 'large',
	    kind: 'ghost',
	    minWidth: 160
	  }
	}];
	
	function Sketch() {
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      title: 'Sketch prototyping in Marvel: sync artboards, hotspots and more',
	      meta: [{
	        name: 'description',
	        content: 'Prototype in Sketch or Marvel'
	      }, {
	        name: 'keywords',
	        content: 'sketch, prototyping'
	      }],
	      header: true,
	      footer: true
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'overflow-hidden' },
	      _react2.default.createElement(
	        'div',
	        { className: _generalModule2.default.wrap },
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'xl', position: 'bottom' },
	          _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.illustration, { hasShadow: false, maxWidth: 860 }))
	        ),
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: 600 },
	          _react2.default.createElement(
	            'h1',
	            { className: _generalModule2.default.heading },
	            'Your Sketch workflow, reimagined'
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'l', type: 'padding', position: 'bottom' },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'xxl', className: _generalModule2.default.subheading },
	              'Seamlessly import prototypes and sync artboards from Sketch into Marvel, then handoff code and help bring teams together.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _generalModule2.default.buttons },
	          _react2.default.createElement(
	            'div',
	            { className: _generalModule2.default.margin },
	            _react2.default.createElement(
	              _link2.default,
	              {
	                url: 'https://storage.googleapis.com/sketch-plugin/Marvel.zip',
	                type: 'opaqueReversed',
	                hasUnderline: true,
	                target: '_blank'
	              },
	              _react2.default.createElement(
	                _button2.default,
	                { size: 'extraLarge', shape: 'rounded', minWidth: 170 },
	                'Download Sketch Plugin'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Whitespace2.default, { size: 'm', sizeM: 'xl' }),
	        _react2.default.createElement(_ImageBlock2.default, {
	          isRightAligned: true,
	          artwork: _assets2.default.prototyping,
	          title: 'Import Sketch prototypes into Marvel',
	          copy: 'Send your hotspots to Marvel and create prototypes that  update as and when you make changes in Sketch - no need to  reorganise or revisit. We speak Sketch\'s language, leaving  you with more time for problem solving.'
	        }),
	        _react2.default.createElement(_Whitespace2.default, { size: 's', sizeM: 'l' }),
	        _react2.default.createElement(_ImageBlock2.default, {
	          artwork: _assets2.default.collaborate,
	          copy: 'Effortlessly sync artboards from Sketch to new or existing Marvel projects. Automated syncing means less manual work for you and your team and creates a centralised space for how your team collaborates.',
	          title: 'Design, sync, work together'
	        }),
	        _react2.default.createElement(_Whitespace2.default, { size: 'm', sizeM: 'l' }),
	        _react2.default.createElement(_FeaturesBlockList2.default, null),
	        _react2.default.createElement(_Whitespace2.default, { size: 'm', sizeM: 'xl' }),
	        _react2.default.createElement(_ImageBlock2.default, {
	          isRightAligned: true,
	          artwork: _assets2.default.embed,
	          title: 'Bring it to life in Marvel',
	          copy: _react2.default.createElement(
	            'span',
	            null,
	            'Take your prototypes to the next level with a wider range of transitions, ability to embed video and link to URLs. Our library of integrations means it doesn\u2019t have to stop there, create meaningful user tests with',
	            ' ',
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/integrations/maze' },
	              _react2.default.createElement(
	                _link2.default,
	                { type: 'blue' },
	                'Maze'
	              )
	            ),
	            ' ',
	            'or streamline product management with our',
	            ' ',
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/integrations/atlassian-jira' },
	              _react2.default.createElement(
	                _link2.default,
	                { type: 'blue' },
	                'JIRA integration '
	              )
	            ),
	            ' ',
	            'and more.',
	            ' '
	          )
	        })
	      ),
	      _react2.default.createElement(_Whitespace2.default, { size: 'l', sizeM: 'l' }),
	      _react2.default.createElement(_CtaDefault2.default, {
	        bgColor: 'snow',
	        buttons: buttons,
	        maxWidth: 700,
	        title: 'Join millions of creatives using Marvel every day.',
	        size: 'xxxxl'
	      })
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = FeaturesBlockList;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _assets = __webpack_require__(122);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _Feature = __webpack_require__(45);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FeaturesBlockList() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { type: 'padding', size: 'l', sizeM: '0', position: 'bottom' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { type: 'margin', size: 'm', position: 'bottom' },
	      _react2.default.createElement(_HeadingBlock2.default, {
	        maxWidth: 620,
	        alignContent: 'center',
	        alignM: 'center',
	        title: 'Strengthen product teams and transform workflows',
	        paragraphSize: 'm',
	        copy: _react2.default.createElement(
	          'span',
	          null,
	          'Consolidate the entire design process with Marvel + Sketch. Sync, create, record and bridge the gap between design and development with access to Handoff and watch your teams efficiency reach new levels.'
	        ),
	        justifyContent: 'center',
	        justifyM: 'center',
	        size: 'l'
	      })
	    ),
	    _react2.default.createElement(
	      _grid2.default,
	      { columns: 3, size: 'l' },
	      _react2.default.createElement(
	        _grid.GridItem,
	        { columnSpan: 3, columnSpanM: 1 },
	        _react2.default.createElement(_Feature2.default, _extends({}, _assets2.default.devices, {
	          title: 'Access anywhere',
	          copy: 'Your designs are no longer tied to one device. Access and collaborate anywhere with our web platform, iOS and Android apps.',
	          maxWidth: 365,
	          fontWeight: 'semibold'
	        }))
	      ),
	      _react2.default.createElement(
	        _grid.GridItem,
	        { columnSpan: 3, columnSpanM: 1 },
	        _react2.default.createElement(_Feature2.default, _extends({}, _assets2.default.record, {
	          title: 'Play, record, share',
	          copy: 'Play prototypes without leaving Sketch to double check flows, then record videos of your prototype flow to share with clients and stakeholders.',
	          maxWidth: 365,
	          fontWeight: 'semibold'
	        }))
	      ),
	      _react2.default.createElement(
	        _grid.GridItem,
	        { columnSpan: 3, columnSpanM: 1 },
	        _react2.default.createElement(_Feature2.default, _extends({}, _assets2.default.handoff, {
	          title: 'Developer ready',
	          copy: 'Every artboard you add from Sketch is automatically transformed into code, specs and assets, ready for developers to start working.',
	          maxWidth: 365,
	          fontWeight: 'semibold'
	        }))
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ImageBlock;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _RevealWrapper = __webpack_require__(57);
	
	var _RevealWrapper2 = _interopRequireDefault(_RevealWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ImageBlock(_ref) {
	  var copy = _ref.copy,
	      title = _ref.title,
	      artwork = _ref.artwork,
	      isRightAligned = _ref.isRightAligned;
	
	  return _react2.default.createElement(
	    _RevealWrapper2.default,
	    null,
	    _react2.default.createElement(
	      _grid2.default,
	      { columns: 12, alignItems: 'center' },
	      _react2.default.createElement(
	        _grid.GridItem,
	        { columnSpan: 12, columnSpanM: 6 },
	        isRightAligned ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactResponsive2.default,
	            { maxWidth: 769 },
	            _react2.default.createElement(
	              _spacing2.default,
	              { type: 'padding', size: 'm', position: 'bottom' },
	              _react2.default.createElement(_Image2.default, _extends({}, artwork, { hasShadow: false }))
	            )
	          ),
	          _react2.default.createElement(_HeadingBlock2.default, {
	            justifyM: 'start',
	            justify: 'center',
	            maxWidth: 420,
	            title: title,
	            copy: copy,
	            paragraphSize: 'm'
	          })
	        ) : _react2.default.createElement(_Image2.default, _extends({}, artwork, { hasShadow: false }))
	      ),
	      _react2.default.createElement(
	        _grid.GridItem,
	        { columnSpan: 12, columnSpanM: 6, alignContent: 'center' },
	        isRightAligned ? _react2.default.createElement(
	          _reactResponsive2.default,
	          { minWidth: 770 },
	          _react2.default.createElement(_Image2.default, _extends({}, artwork, { hasShadow: false }))
	        ) : _react2.default.createElement(_HeadingBlock2.default, {
	          maxWidth: 420,
	          paragraphSize: 'm',
	          title: title,
	          copy: copy
	        })
	      )
	    )
	  );
	}
	
	ImageBlock.propTypes = {
	  artwork: _propTypes2.default.object,
	  copy: _propTypes2.default.string,
	  color: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  paragraphSize: _propTypes2.default.oneOf(['xs', 's', 'm', 'l', 'xl', 'xxl']),
	  isRightAligned: _propTypes2.default.bolean
	};
	
	ImageBlock.defaultProps = {
	  isRightAligned: false
	};
	module.exports = exports['default'];

/***/ }),

/***/ 760:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrap":"src-pages-sketch-style----general-module---wrap---39AQf pageWrap c-black textAlign-center pageWrap-l","heading":"src-pages-sketch-style----general-module---heading---1rcFd fontWeight-5 marginBottom-m fontSize-xxxl lineHeight-title breakPointS-fontSize-xxxxl","subheading":"src-pages-sketch-style----general-module---subheading---2qMkY lineHeight-copy breakPointS-fontSize-xl breakPointM-fontSize-xxl breakPointM-lineHeight-xxl fontWeight-4 c-slate","buttons":"src-pages-sketch-style----general-module---buttons---1opgx breakPointS-inline","margin":"src-pages-sketch-style----general-module---margin---1JBWd marginBottom-s breakPointS-marginBottom-0 breakPointS-marginRight-m"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sketch-prototyping-index-js-83b55f65c4d8046144bb.js